module.exports = __webpack_public_path__ + "static/media/kofi_mobile_outline.d41484bf.png";